// ⚠️  Please reach out to Franco (or Ben if he's out) before editing this file ⚠️
// This file follows the same setup as `stencil-ds-output-targets` (https://github.com/ionic-team/stencil-ds-output-targets/blob/main/packages/example-project/component-library/src/index.ts).
export * from "./components";
